export default function _arrayWithHoles(_0x2ecf63){if(Array['isArray'](_0x2ecf63))return _0x2ecf63;}